module.exports = __webpack_public_path__ + "img/medalCopper.ad653e4f.png";